import type { NavNode } from "../lib/types";
import { NavLink, useLocation } from "react-router-dom";

interface SidebarProps {
  navTree: NavNode[];
  onNavigate?: () => void;
}

export function Sidebar({ navTree, onNavigate }: SidebarProps) {
  const location = useLocation();

  return (
    <nav className="sidebar-nav" aria-label="Help Centre navigation">
      <ul className="nav-list">
        {navTree.map((node) => (
          <NavNodeItem key={node.article.slug} node={node} onNavigate={onNavigate} />
        ))}
      </ul>
    </nav>
  );
}

function NavNodeItem({
  node,
  onNavigate,
}: {
  node: NavNode;
  onNavigate?: () => void;
}) {
  const location = useLocation();
  const isActive = location.pathname === node.article.slug;
  const isSection = node.article.page_type === "section";
  const isHome = node.article.page_type === "home";

  return (
    <li className="nav-item">
      <NavLink
        to={node.article.slug}
        end={node.article.slug === "/"}
        className={`nav-link ${isActive ? "active" : ""} ${
          isSection ? "nav-section" : ""
        } ${isHome ? "nav-home" : ""}`}
        onClick={onNavigate}
      >
        {node.article.title}
      </NavLink>
      {node.children.length > 0 && (
        <ul className="nav-list nav-children">
          {node.children.map((child) => (
            <NavNodeItem key={child.article.slug} node={child} onNavigate={onNavigate} />
          ))}
        </ul>
      )}
    </li>
  );
}
